<template>
  <div id="pers-salary" name="hres8ax-salary" class="content-pers clearfix">
    <div class="col-xs-12 col-md-12">  

      <div class="income-summary-box">
        <div class="label-topic">{{ labels['HRES8AXC1']['20'] }}</div>
        <div class="income color-skin">{{detailSalary.amtsalyr}} {{ labels['HRES8AXC1']['80'] }}</div>
        <div class="vat-box clearfix">
          <div class="label-vat">{{ labels['HRES8AXC1']['30'] }}</div>
          <div class="vat color-skin">{{detailSalary.amttaxt}} {{ labels['HRES8AXC1']['80'] }}</div>
        </div>
      </div>

      <div class="cal-input-group clearfix">
        <div class="cal-topic color-skin clearfix">{{ labels['HRES8AXC1']['40'] }} {{detailSalary.dteyrepay}}</div>

        <div class="col-xs-12 col-md-3 ">
          <div class="data-box clearfix" >
            <div class="data-row ">
              <div class="col-xs-12 data-label clear-padding" style="text-align: left">{{ labels['HRES8AXC1']['50'] }}</div>
            </div>
          </div>
          <div class="data-box clearfix">
            <div class="data-row ">
              <div class="col-xs-12 data-input clear-padding">
                <div class="form-control readonly-field-color" style="text-align:right;">{{detailSalary.amtincom1}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-3">
          <div class="data-box " >
            <div class="data-row ">
              <div class="col-xs-12 data-label clear-padding">{{ labels['HRES8AXC1']['30'] }}</div>
            </div>
          </div>
          <div class="data-box " >
            <div class="data-row ">
              <div class="col-xs-12 data-input clear-padding">
                <div class="form-control readonly-field-color" style="text-align:right;">{{detailSalary.amttaxt}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-3">
          <div class="data-box " >
            <div class="data-row ">
              <div class="col-xs-12 data-label clear-padding">{{ labels['HRES8AXC1']['60'] }}</div>
            </div>
          </div>
          <div class="data-box " >
            <div class="data-row ">
              <div class="col-xs-12 data-input clear-padding">
                <div class="form-control readonly-field-color" style="text-align:right;">{{detailSalary.amtsalt}}</div>
              </div>
            </div>
          </div>
        </div>
       
        <div class="col-xs-12 col-md-3">
          <div class="data-box " >
            <div class="data-row ">
              <div class="col-xs-12 data-label clear-padding">{{ labels['HRES8AXC1']['70'] }}</div>
            </div>
          </div>
          <div class="data-box " >
            <div class="data-row ">
              <div class="col-xs-12 data-input clear-padding">
                <input type="text" class="form-control input-text" id="amtothyr" name="amtothyr" v-model="detailSalary.amtothyr" style="text-align:right;"/>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hres8ax-salary',
  props: [ 'labels', 'detailSalary' ]
}
</script>


// WEBPACK FOOTER //
// salary.vue?5bb39780